// API returns slotSize as a decimal string ("1.5"); null means a people-based pack
export const formatSlotSize = (slotSize: number | string | null | undefined): string => {
  if (slotSize === null || slotSize === undefined || slotSize === "") return "-";
  const hours = Number(slotSize);
  return `${hours} hr${hours !== 1 ? "s" : ""}`;
};
